import React, { useState } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  FormGroup,
  Breadcrumb,
} from "react-bootstrap";
import { addExpediteVisitOption } from "../../actions/expediteVisitAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

const optionSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, "Title must have at least 2 characters")
    .max(200, "Title can't be longer than 200 characters")
    .required("Title field is required"),
  timeZone: Yup.string()
    .min(2, "Time Frame must have at least 2 characters")
    .max(100, "Time Frame can't be longer than 100 characters")
    .required("Time Frame field is required"),
  description: Yup.string()
    .min(10, "Description must have at least 10 characters")
    .max(500, "Description can't be longer than 500 characters")
    .required("Description field is required"),
  price: Yup.number()
    .required("Price field is required")
    .test("is-greater-than-zero", "Price must be greater than zero", function(value) {
      if (value === undefined || value === null) return false;
      return value > 0;
    }),
  "agreement.title": Yup.string()
    .max(200, "Agreement title can't be longer than 200 characters"),

     agreamentText: Yup.string()
    .min(2, "agreament Text must have at least 2 characters")
    .max(500, "agreament Text can't be longer than 500 characters")
    // .required("agreament Text field is required"),
});

const AddOption = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [agreementTerms, setAgreementTerms] = useState([""]);

  const formik = useFormik({
    initialValues: {
      title: "",
      timeZone: "",
      // suffix: "",
      description: "",
      agreamentText:"",
      price: 0,
      agreement: {
        title: "",
        terms: [],
      },
    },
    validationSchema: optionSchema,
    onSubmit: async (values) => {
      setLoader(true);
      const submitData = {
        ...values,
        agreement: {
          title: values.agreement.title || "Agreement",
          terms: agreementTerms.filter((term) => term.trim() !== ""),
        },
      };
      let res = await addExpediteVisitOption(submitData);
      if (res?.data?.success) {
        navigate("/service-add-on");
        toast.success(res.data.message);
      }
      setLoader(false);
    },
  });

  const addAgreementTerm = () => {
    setAgreementTerms([...agreementTerms, ""]);
  };

  const removeAgreementTerm = (index) => {
    const newTerms = agreementTerms.filter((_, i) => i !== index);
    setAgreementTerms(newTerms);
  };

  const updateAgreementTerm = (index, value) => {
    const newTerms = [...agreementTerms];
    newTerms[index] = value;
    setAgreementTerms(newTerms);
  };

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Add Service Add-on
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form onSubmit={formik.handleSubmit}>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Title <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              placeholder="Enter add-on title"
                              onChange={formik.handleChange}
                              value={formik.values.title}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.title && formik.errors.title ? (
                              <span className={formik.errors.title ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.title}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Time Frame <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="timeZone"
                              placeholder="e.g., under 10 minutes, 20-30 minutes, 2-3 hours"
                              onChange={formik.handleChange}
                              value={formik.values.timeZone}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.timeZone && formik.errors.timeZone ? (
                              <span className={formik.errors.timeZone ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.timeZone}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              name="description"
                              placeholder="Enter description"
                              onChange={formik.handleChange}
                              value={formik.values.description}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.description && formik.errors.description ? (
                              <span className={formik.errors.description ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.description}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>
                              Add‑on Price <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="price"
                              placeholder="Enter the add-on price (i.e., 30, 49.99, etc.)"
                              // min="1"
                              step="0.01"
                              onChange={formik.handleChange}
                              value={formik.values.price}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.price && formik.errors.price ? (
                              <span className={formik.errors.price ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.price}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Card className="mb-3">
                            <Card.Header>
                              <Card.Title as="h5">Agreement</Card.Title>
                            </Card.Header>
                            <Card.Body>
                              <Form.Group className="mb-3">
                                <Form.Label>Agreement Title (Optional)</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="agreement.title"
                                  placeholder="Enter agreement title"
                                  onChange={formik.handleChange}
                                  value={formik.values.agreement.title}
                                  onBlur={formik.handleBlur}
                                />
                                {formik.touched["agreement.title"] && formik.errors["agreement.title"] ? (
                                  <span className={formik.errors["agreement.title"] ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {formik.errors["agreement.title"]}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <Form.Label>Agreement Terms</Form.Label>
                                  <Button
                                    type="button"
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={addAgreementTerm}
                                  >
                                    Add Term
                                  </Button>
                                </div>
                                {agreementTerms.map((term, index) => (
                                  <div key={index} className="d-flex mb-2">
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter agreement term"
                                      value={term}
                                      onChange={(e) => updateAgreementTerm(index, e.target.value)}
                                      className="mr-2"
                                    />
                                    {agreementTerms.length > 1 && (
                                      <Button
                                        type="button"
                                        variant="danger"
                                        size="sm"
                                        onClick={() => removeAgreementTerm(index)}
                                      >
                                        Remove
                                      </Button>
                                    )}
                                  </div>
                                ))}
                              </Form.Group>
                            </Card.Body>
                          </Card>

                           <Form.Group className="mb-3">
                            <Form.Label>
                              Agreament Text <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="agreamentText"
                              placeholder="Enter Agreament Text"
                              onChange={formik.handleChange}
                              value={formik.values.agreamentText}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.agreamentText && formik.errors.agreamentText ? (
                              <span className={formik.errors.agreamentText ? `` : `d-none`}>
                                <label className="pl-1 text-danger">
                                  {formik.errors.agreamentText}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Button className="btn-filled" type="submit">
                            Submit
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default AddOption;


